




































































import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import { MerchantDetailsModel } from '@/models/MerchantDetailsModel';
import ActionTypes from '@/constants/action-types';
import { daysOfTheWeekShort } from '@/utils/date-utils';
import { OperatingHoursModel } from '@/models/OperatingHoursModel';
import moment from 'moment';

@Component
export default class PickupSelectCard extends Vue {
  @Prop() private readonly showTimePopover!: boolean;

  private pickupDate: moment.Moment | null = null;

  private pickupTime: moment.Moment | null = null;

  private times: moment.Moment[] = [];

  mounted() {
    this.checkPickupDateTime(this.showTimePopover);
  }

  @Watch('pickupDate')
  private onDayChange() {
    this.pickupTime = null;
    this.checkTimes();
  }

  @Watch('showTimePopover')
  private checkPickupDateTime(showTimePopover: boolean) {
    if (showTimePopover && this.pickupDateTime) {
      const selectedDate = this.pickupDateTime.clone().tz(this.merchant.timezone).startOf('day');
      this.pickupDate = this.days.find((e) => e.value?.toISOString() === selectedDate.toISOString())?.value || null;

      this.checkTimes();
      this.$nextTick(() => {
        if (this.pickupDateTime?.isAsapTime) {
          this.pickupTime = this.times[0] || null;
        } else {
          this.pickupTime = this.times.find((e) => e.toISOString() === this.pickupDateTime?.toISOString()) || null;
        }
      });
    }
  }

  private get pickupDateTime(): moment.Moment | null {
    return this.$store.state.cart.pickupDateTime;
  }

  private get merchant(): MerchantDetailsModel {
    return this.$store.state.merchant.merchant;
  }

  private get operatingHours(): OperatingHoursModel[] {
    return this.merchant.operatingHours;
  }

  private get days(): Array<{ value: moment.Moment | null; label: string; closed?: boolean }> {
    const today: moment.Moment = moment.tz(this.merchant.timezone).startOf('day');

    const days = [...new Array(this.merchant.orderAheadNumDays + 1).keys()].map((e) => {
      const value = today.clone().add(e, 'days');
      const operatingHour = this.operatingHours.find((o) => daysOfTheWeekShort.indexOf(o.day) === value.day());

      if (operatingHour?.open && operatingHour?.close) {
        return { value, label: value.format('ddd, MMM D') };
      }
      return { value, label: 'Closed', closed: true };
    });

    if (this.daysClosed(days)) {
      return [{ value: null, label: 'Whatever Date - Closed', closed: true }];
    }
    return days;
  }

  private get dateDisabled(): boolean {
    return !this.pickupDateTime || this.daysClosed(this.days);
  }

  private daysClosed(days: Array<{ value: moment.Moment | null; label: string; closed?: boolean }>): boolean {
    return days.map((e) => Boolean(e.closed)).reduce((p, c) => p && c, true);
  }

  private checkTimes(): void {
    if (!this.pickupDate) {
      this.times = [];
      return;
    }
    const operatingHour = this.operatingHours.find((o) => daysOfTheWeekShort.indexOf(o.day) === this.pickupDate?.day());

    if (!(operatingHour && operatingHour.open)) {
      this.times = [];
      return;
    }
    const arr: moment.Moment[] = [];

    const open = new Date(operatingHour.open);
    const close = new Date(operatingHour.close);

    let time = this.pickupDate.clone().add(open.getUTCHours() * 60 + open.getUTCMinutes() + 15, 'minutes');
    const closeTime = this.pickupDate.clone().add(close.getUTCHours() * 60 + close.getUTCMinutes(), 'minutes');

    const now = moment().tz(this.merchant.timezone);
    // Check is today and add ASAP time
    if (this.pickupDate.isSame(now, 'day')) {
      const asap = now.clone().seconds(0).milliseconds(0);
      asap.isAsapTime = true;
      arr.push(asap);
    }

    while (time.isBefore(closeTime)) {
      if (time.diff(now, 'minutes') > 10) {
        arr.push(time);
      }
      time = time.clone().add(15, 'minutes');
    }

    this.times = arr;
  }

  private getTimeText(time: moment.Moment): string {
    return time.isAsapTime ? 'ASAP' : time.format('hh:mm A');
  }

  private save(): void {
    this.$store.commit(`cart/${ActionTypes.SetPickupDateTime}`, this.pickupTime);
    this.$emit('close');
  }
}
